import {
    AfterViewInit,
    Directive,
    ElementRef,
    Input,
    NgZone,
    OnDestroy,
    Renderer2,
    RendererFactory2,
} from '@angular/core';

@Directive({
    standalone: false,
    selector: '[ycnAutoDropDirection]',
})
export class AutoDropDirectionDirective implements AfterViewInit, OnDestroy {
    @Input() ycnAutoDropDirection!: boolean;

    private observer: MutationObserver | undefined;

    private renderer: Renderer2;

    constructor(private el: ElementRef, private ngZone: NgZone, private rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    ngAfterViewInit(): void {
        if (!this.ycnAutoDropDirection) return;

        this.ngZone.runOutsideAngular(() => {
            const element = this.el.nativeElement;

            this.observer = new MutationObserver((mutations: MutationRecord[]) => {
                // Only react to class changes on descendant elements (e.g. the menu getting .show).
                // Ignore mutations on the host element itself to avoid an infinite loop
                // since updateDropDirection adds/removes 'dropup' on the host.
                if (mutations.some((m) => m.target !== element)) {
                    this.updateDropDirection(element);
                }
            });

            this.observer.observe(element, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true,
            });
        });
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private updateDropDirection(element: HTMLElement): void {
        const menu = element.querySelector('.dropdown-menu.show') as HTMLElement | null;
        if (!menu) {
            this.renderer.removeClass(element, 'dropup');
            return;
        }

        const parentRect = element.getBoundingClientRect();
        const menuHeight = menu.offsetHeight;
        const spaceBelow = window.innerHeight - parentRect.bottom - 50;
        const spaceAbove = parentRect.top;

        if (menuHeight > spaceBelow && spaceAbove > spaceBelow) {
            this.renderer.addClass(element, 'dropup');
        } else {
            this.renderer.removeClass(element, 'dropup');
        }
    }
}
